// Hook: DELETE /company/departments/{id}

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteCompanyDepartment = (id: number): Promise<IResponse> =>
  axios.delete(`/company/departments/${id}`);

export const useDeleteCompanyDepartment = (
  options?: UseMutationOptions<IResponse, IError, number>
) => useMutation((id: number) => deleteCompanyDepartment(id), options);
